import getPkce from 'oauth-pkce'

const getCodes = (): Promise<{
  code_verifier: string
  code_challenge: string
}> => {
  return new Promise((resolve, reject) => {
    getPkce(43, (error, { verifier, challenge }) => {
      if (error) reject(error)

      resolve({
        code_challenge: challenge,
        code_verifier: verifier,
      })
    })
  })
}

export { getCodes }
